import {
    AccordionContent,
    AccordionItem as AccordionItemPrimitive,
    AccordionTrigger,
} from '@talentmesh/ui/components/accordion';
import { cn } from '@talentmesh/ui/lib/utils';
import React from 'react';
import PanelContainer from './PanelContainer';

interface AccordionItemProps {
    value: string;
    header: string;
    children: React.ReactNode;
}

function AccordionItem({ value, header, children }: AccordionItemProps) {
    return (
        <AccordionItemPrimitive value={value} className="border-border not-last:border-b">
            <AccordionTrigger
                className={cn('text-foreground mx-2.5 py-3 text-sm font-normal', 'data-[state=open]:font-medium')}
            >
                {header}
            </AccordionTrigger>
            <AccordionContent>
                <PanelContainer>{children}</PanelContainer>
            </AccordionContent>
        </AccordionItemPrimitive>
    );
}

export default AccordionItem;
